import React from 'react'
import Img from 'gatsby-image'
import { StaticQuery, graphql } from 'gatsby'

import TextSection from './textSection'
import MainPartners from './mainPartners'

const Partners = () => (
  <StaticQuery
    query={graphql`
      query partnersQuery {
        OXFAM: file(relativePath: { eq: "partners/OXFAM.png" }) {
          childImageSharp {
            id
            fixed(width: 350) {
              originalName
              ...GatsbyImageSharpFixed_withWebp
            }
          }
        }
        DAPP: file(relativePath: { eq: "partners/DAPP.png" }) {
          childImageSharp {
            id
            fixed(width: 350) {
              originalName
              ...GatsbyImageSharpFixed_withWebp
            }
          }
        }
        ASRT: file(relativePath: { eq: "partners/ASRT.png" }) {
          childImageSharp {
            id
            fixed(width: 350) {
              originalName
              ...GatsbyImageSharpFixed_withWebp
            }
          }
        }
        INNOVATIONCLUSTER: file(
          relativePath: { eq: "partners/INNOVATION-CLUSTER.png" }
        ) {
          childImageSharp {
            id
            fixed(width: 350) {
              originalName
              ...GatsbyImageSharpFixed_withWebp
            }
          }
        }
        NTRA: file(relativePath: { eq: "partners/NTRA.png" }) {
          childImageSharp {
            id
            fixed(width: 350) {
              originalName
              ...GatsbyImageSharpFixed_withWebp
            }
          }
        }
        VC4A: file(relativePath: { eq: "partners/VC4A.png" }) {
          childImageSharp {
            id
            fixed(width: 250) {
              originalName
              ...GatsbyImageSharpFixed_withWebp
            }
          }
        }
        USAID: file(relativePath: { eq: "partners/USAID.png" }) {
          childImageSharp {
            id
            fixed(width: 250) {
              originalName
              ...GatsbyImageSharpFixed_withWebp
            }
          }
        }
        #
        AASMT: file(relativePath: { eq: "partners/AASMT.png" }) {
          childImageSharp {
            id
            fixed(width: 190) {
              originalName
              ...GatsbyImageSharpFixed_withWebp
            }
          }
        }

        SUEZUNIVERSITY: file(
          relativePath: { eq: "partners/SUEZ-UNIVERSITY.png" }
        ) {
          childImageSharp {
            id
            fixed(width: 190) {
              originalName
              ...GatsbyImageSharpFixed_withWebp
            }
          }
        }
        MASRELKHIER: file(relativePath: { eq: "partners/MASR-EL-KHIER.png" }) {
          childImageSharp {
            id
            fixed(width: 190) {
              originalName
              ...GatsbyImageSharpFixed_withWebp
            }
          }
        }
      }
    `}
  >
    {data => {
      const partners = Object.values(data).map(partner => ({
        id: partner.childImageSharp.id,
        name: partner.childImageSharp.fixed.originalName,
        image: partner.childImageSharp.fixed,
      }))

      return (
        <TextSection className="partners" withoutContainer={true}>
          <div className="partners__logos">
            <MainPartners />
            {partners.map(partner => (
              <Img key={partner.id} alt={partner.name} fixed={partner.image} />
            ))}
          </div>
        </TextSection>
      )
    }}
  </StaticQuery>
)

export default Partners
